import React, { StrictMode } from 'react';
import { render } from 'react-dom';
import { Provider } from 'react-redux';
import { ThemeProvider } from "@material-ui/core/styles";
import * as serviceWorker from './serviceWorker';
import store from './store';
import './index.css';
//import './popup.css';
import theme from './themes/theme.js'
import AppGuard from './components/AppGuard';
import AppRouter from './appRouter.js';

render(
  <StrictMode>
    <ThemeProvider theme={theme}>
      <Provider store={store}>
        <AppRouter>
          <AppGuard />
        </AppRouter>
      </Provider>
    </ThemeProvider>
  </StrictMode>,
  document.getElementById('root')
);

serviceWorker.unregister();
